(function () {
    'use strict';

    angular.module("imApp").factory("priceListService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 650,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 660,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
